module.exports = new __parcel__URL__("SpotlightGif.cc562f5c.gif").toString();